module.exports = __webpack_public_path__ + "static/img/通用型设备.ef33425.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/通用型设备.jpg
// module id = 2llY
// module chunks = 1